import { CoreApi, ProductType } from '@inter-ikea-storageone/range';
import { NoneOption, ProductListConfig } from 'rangeConfig/@types';
import { default as autoFillHandlesBesta } from 'rangeConfig/besta/behaviors/autoFillHandles';
import showDoors from 'rangeConfig/shared/behaviors/showDoors';
import { ComponentIds } from '@inter-ikea-core/core';
import addHandleToFront from 'rangeConfig/besta/behaviors/addHandleToFront';
import IntegratedHandlesInfoMessage from 'components/ProductSidebar/CategoryWidget/IntegratedHandlesMessage';
import {
  matchHandleSizeToFrontsInScene,
  matchHandleTypeToFronts
} from 'rangeConfig/shared/filters/mainMenuProductFilters';
import { getAllowedHandleTypes } from 'rangeConfig/shared/utils/frontLayouts';
import removeAllHandlesFromScene from 'rangeConfig/shared/behaviors/removeAllHandlesFromScene';

const frontsWithNoHandlesInScene = (coreApi: CoreApi) => {
  const frontsInScene = coreApi.entities.getByComponents([
    ComponentIds.DOOR_COMPONENT_ID,
    ComponentIds.DRAWER_COMPONENT_ID
  ]);
  const frontsWithoutIncludedHandlesInScene = frontsInScene.filter(
    front => getAllowedHandleTypes(front).length > 0
  );
  const handlesInScene = coreApi.entities.getByComponent(ComponentIds.HANDLE_COMPONENT_ID);
  return frontsWithoutIncludedHandlesInScene.length > handlesInScene.length;
};

const noneOptionFrontLayout: NoneOption = {
  title: 'storageone.productListNoHandlesOptionTitle',
  subtitle: 'storageone.productListNoHandlesOptionSubtitle',
  behaviors: { removeProducts: [removeAllHandlesFromScene] },
  selected: frontsWithNoHandlesInScene
};

const handlesProductListConfig: ProductListConfig = {
  cardsTitle: 'name',
  cardsSubtitle: 'typeName, designText, communicatedSizeText',
  behaviors: {
    productClicked: [showDoors, autoFillHandlesBesta],
    productDropped: [addHandleToFront]
  },
  cluster: [],
  productFilters: [matchHandleSizeToFrontsInScene, matchHandleTypeToFronts],
  sortOrder: [{ path: 'name' }, { path: 'dimensions.height' }, { path: 'dimensions.width' }],
  categories: [
    {
      id: 'handles',
      products: [
        { path: 'type', value: ProductType.HANDLE },
        { path: 'type', value: ProductType.EDGE_HANDLE },
        { path: 'type', value: ProductType.KNOB }
      ],
      noneOption: noneOptionFrontLayout,
      widgets: [{ component: IntegratedHandlesInfoMessage, alwaysShow: true }]
    }
  ]
};

export default handlesProductListConfig;
